const QUERIES = {
  USERS_LIST: 'users',
  HOTELS_LIST: 'hotels',
  FOOTER_LIST:'footer',
  HEADER_LIST:'header',
  CONTACT_PAGE:"contact",
  ABOUT_PAGE:"about",
  FACILITIES_LIST:"facilities",
  THEMES_LIST:"themes",
  OPTION_LIST:"options",
  PAGES_LIST:'pages',
  SECTION_LIST:"/blocks",
  RESERVATIONS_LIST: 'reservations',
  STATUSES_LIST: 'status',
  PAYMENT_METHODS_LIST: 'payment-methods'
}

export {QUERIES}
